module.exports = __webpack_public_path__ + "img/asana.d7bf62c1.svg";